import { render, staticRenderFns } from "./videoParam.vue?vue&type=template&id=7b96cda3&scoped=true"
import script from "./videoParam.vue?vue&type=script&lang=js"
export * from "./videoParam.vue?vue&type=script&lang=js"
import style0 from "./videoParam.vue?vue&type=style&index=0&id=7b96cda3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96cda3",
  null
  
)

export default component.exports